export default __webpack_public_path__ + "static/media/Recording.7d54d28b.svg";